import { CompleteKundali } from '../types/kundali';
import { NAKSHATRAS } from './vedicEngine';

export interface PlanetLordDeityInfo {
  planet: string;
  planetHi: string;
  supremeGod: string;
  supremeGodHi: string;
  godTitle: string;
  godTitleHi: string;
  godSignificance: string;
  godSignificanceHi: string;
  mantra: string;
  avatarOrForm: string;
  avatarOrFormHi: string;
}

export const PLANET_SUPREME_DEITIES: Record<string, PlanetLordDeityInfo> = {
  Sun: {
    planet: 'Sun (Surya)',
    planetHi: 'सूर्य (Sun)',
    supremeGod: 'Lord Shiva & Surya Narayana',
    supremeGodHi: 'भगवान शिव एवं श्री सूर्यनारायण',
    godTitle: 'Supreme Atma & Cosmic Light (Soul Illuminator)',
    godTitleHi: 'परमात्मा, आत्मबल एवं प्रकाश पुंज',
    godSignificance: 'Bestows soul power (Atma-bala), royal authority, vitality, dispels ignorance, and burns ancestral karmic debts.',
    godSignificanceHi: 'आत्म-विश्वास, पिता सुख, मान-सम्मान, नेतृत्व क्षमता एवं ओजस्विता प्रदान करते हैं। समस्त दोषों व अंधकार का शमन करते हैं।',
    mantra: 'ॐ ह्रीं सूर्याय नमः / ॐ नमः शिवाय',
    avatarOrForm: 'Lord Rama & Agni Deva',
    avatarOrFormHi: 'श्री राम एवं अग्नि देव'
  },
  Surya: {
    planet: 'Sun (Surya)',
    planetHi: 'सूर्य (Sun)',
    supremeGod: 'Lord Shiva & Surya Narayana',
    supremeGodHi: 'भगवान शिव एवं श्री सूर्यनारायण',
    godTitle: 'Supreme Atma & Cosmic Light',
    godTitleHi: 'परमात्मा, आत्मबल एवं प्रकाश पुंज',
    godSignificance: 'Bestows soul power (Atma-bala), royal authority, vitality, dispels ignorance, and burns ancestral karmic debts.',
    godSignificanceHi: 'आत्म-विश्वास, पिता सुख, मान-सम्मान, नेतृत्व क्षमता एवं ओजस्विता प्रदान करते हैं।',
    mantra: 'ॐ ह्रीं सूर्याय नमः / ॐ नमः शिवाय',
    avatarOrForm: 'Lord Rama & Agni Deva',
    avatarOrFormHi: 'श्री राम एवं अग्नि देव'
  },
  Moon: {
    planet: 'Moon (Chandra)',
    planetHi: 'चन्द्र (Moon)',
    supremeGod: 'Goddess Parvati & Lord Somnath (Shiva)',
    supremeGodHi: 'माता पार्वती एवं भगवान सोमनाथ (शिव)',
    godTitle: 'Divine Mother & Consciousness of Peace',
    godTitleHi: 'चित्त-प्रसाद, मातृ-शक्ति व मानसिक शांति',
    godSignificance: 'Grants deep mental peace (Chitta-shuddhi), emotional intelligence, nurturing grace, intuitive power, and clears anxieties.',
    godSignificanceHi: 'मानसिक शांति, भावनात्मक संतुलन, माता का आशीर्वाद, एकाग्रता एवं सुख-समृद्धि प्रदान करते हैं। अवसाद व भय का नाश करते हैं।',
    mantra: 'ॐ सोमाय नमः / ॐ उमामहेश्वराभ्यां नमः',
    avatarOrForm: 'Lord Krishna & Jal Devata (Varuna)',
    avatarOrFormHi: 'श्री कृष्ण एवं वरुण देव'
  },
  Chandra: {
    planet: 'Moon (Chandra)',
    planetHi: 'चन्द्र (Moon)',
    supremeGod: 'Goddess Parvati & Lord Somnath (Shiva)',
    supremeGodHi: 'माता पार्वती एवं भगवान सोमनाथ (शिव)',
    godTitle: 'Divine Mother & Consciousness of Peace',
    godTitleHi: 'चित्त-प्रसाद, मातृ-शक्ति व मानसिक शांति',
    godSignificance: 'Grants deep mental peace, emotional intelligence, nurturing grace, intuitive power, and clears anxieties.',
    godSignificanceHi: 'मानसिक शांति, भावनात्मक संतुलन, माता का आशीर्वाद, एकाग्रता एवं सुख-समृद्धि प्रदान करते हैं।',
    mantra: 'ॐ सोमाय नमः / ॐ उमामहेश्वराभ्यां नमः',
    avatarOrForm: 'Lord Krishna & Jal Devata (Varuna)',
    avatarOrFormHi: 'श्री कृष्ण एवं वरुण देव'
  },
  Mars: {
    planet: 'Mars (Mangal)',
    planetHi: 'मंगल (Mars)',
    supremeGod: 'Lord Kartikeya (Murugan / Skanda) & Lord Hanuman',
    supremeGodHi: 'भगवान कार्तिकेय (मुरुगन) एवं श्री हनुमान जी',
    godTitle: 'Commander of Valor, Protection & Victory',
    godTitleHi: 'वीरता, रक्षण, पराक्रम व विजय के सेनापति',
    godSignificance: 'Bestows fearless courage (Dhairya), victory over adversarial obstacles, property stability, and channels physical stamina into righteous actions.',
    godSignificanceHi: 'अदम्य साहस, भूमि/संपत्ति लाभ, शत्रुओं पर विजय, शारीरिक ऊर्जा एवं संकट निवारण की अमोघ शक्ति प्रदान करते हैं।',
    mantra: 'ॐ अं अंगारकाय नमः / ॐ हं हनुमते नमः',
    avatarOrForm: 'Lord Narasimha & Bhoomi Devi',
    avatarOrFormHi: 'भगवान नृसिंह एवं भूमि देवी'
  },
  Mangal: {
    planet: 'Mars (Mangal)',
    planetHi: 'मंगल (Mars)',
    supremeGod: 'Lord Kartikeya (Murugan / Skanda) & Lord Hanuman',
    supremeGodHi: 'भगवान कार्तिकेय (मुरुगन) एवं श्री हनुमान जी',
    godTitle: 'Commander of Valor, Protection & Victory',
    godTitleHi: 'वीरता, रक्षण, पराक्रम व विजय के सेनापति',
    godSignificance: 'Bestows fearless courage (Dhairya), victory over adversarial obstacles, property stability, and channels physical stamina into righteous actions.',
    godSignificanceHi: 'अदम्य साहस, भूमि/संपत्ति लाभ, शत्रुओं पर विजय, शारीरिक ऊर्जा एवं संकट निवारण की अमोघ शक्ति प्रदान करते हैं।',
    mantra: 'ॐ अं अंगारकाय नमः / ॐ हं हनुमते नमः',
    avatarOrForm: 'Lord Narasimha & Bhoomi Devi',
    avatarOrFormHi: 'भगवान नृसिंह एवं भूमि देवी'
  },
  Mercury: {
    planet: 'Mercury (Budha)',
    planetHi: 'बुध (Mercury)',
    supremeGod: 'Lord Maha Vishnu & Goddess Saraswati',
    supremeGodHi: 'भगवान महाविष्णु एवं माँ सरस्वती',
    godTitle: 'Supreme Preserver of Intellect, Speech & Commerce',
    godTitleHi: 'बुद्धि, वाणी, विवेक व व्यापार के अधिष्ठाता',
    godSignificance: 'Cultivates sharp analytical discernment (Buddhi), commercial mastery, eloquence, business diplomacy, and eliminates mental confusion.',
    godSignificanceHi: 'कुशाग्र बुद्धि, वाकपटुता, व्यापारिक सफलता, एकाग्रता एवं विद्या में अद्वितीय निपुणता प्रदान करते हैं।',
    mantra: 'ॐ बुं बुधाय नमः / ॐ नमो भगवते वासुदेवाय',
    avatarOrForm: 'Lord Buddha & Hayagriva',
    avatarOrFormHi: 'भगवान बुद्ध एवं हयग्रीव'
  },
  Budha: {
    planet: 'Mercury (Budha)',
    planetHi: 'बुध (Mercury)',
    supremeGod: 'Lord Maha Vishnu & Goddess Saraswati',
    supremeGodHi: 'भगवान महाविष्णु एवं माँ सरस्वती',
    godTitle: 'Supreme Preserver of Intellect, Speech & Commerce',
    godTitleHi: 'बुद्धि, वाणी, विवेक व व्यापार के अधिष्ठाता',
    godSignificance: 'Cultivates sharp analytical discernment (Buddhi), commercial mastery, eloquence, business diplomacy, and eliminates mental confusion.',
    godSignificanceHi: 'कुशाग्र बुद्धि, वाकपटुता, व्यापारिक सफलता, एकाग्रता एवं विद्या में अद्वितीय निपुणता प्रदान करते हैं।',
    mantra: 'ॐ बुं बुधाय नमः / ॐ नमो भगवते वासुदेवाय',
    avatarOrForm: 'Lord Buddha & Hayagriva',
    avatarOrFormHi: 'भगवान बुद्ध एवं हयग्रीव'
  },
  Jupiter: {
    planet: 'Jupiter (Guru)',
    planetHi: 'बृहस्पति / गुरु (Jupiter)',
    supremeGod: 'Lord Shiva (Dakshinamurthy) & Lord Brahma',
    supremeGodHi: 'भगवान दक्षिणामूर्ति (शिव) एवं श्री ब्रह्मा जी',
    godTitle: 'Supreme Guru of Divine Wisdom, Fortune & Grace',
    godTitleHi: 'परम गुरु, ज्ञान, भाग्य एवं दिव्यता के दाता',
    godSignificance: 'Bestows higher spiritual evolution, divine grace (Guru Kripa), righteous progeny, ethical wealth, expansive fortune (Bhagya), and shields against malice.',
    godSignificanceHi: 'दिव्य ज्ञान, आध्यात्मिक उन्नति, संतान सुख, भाग्य वृद्धि, उच्च शिक्षा एवं सभी संकटों से दैवीय सुरक्षा प्रदान करते हैं।',
    mantra: 'ॐ बृं बृहस्पतये नमः / ॐ दक्षिणामूर्तये नमः',
    avatarOrForm: 'Lord Vamana & Lord Brihaspati',
    avatarOrFormHi: 'भगवान वामन एवं देवगुरु बृहस्पति'
  },
  Guru: {
    planet: 'Jupiter (Guru)',
    planetHi: 'बृहस्पति / गुरु (Jupiter)',
    supremeGod: 'Lord Shiva (Dakshinamurthy) & Lord Brahma',
    supremeGodHi: 'भगवान दक्षिणामूर्ति (शिव) एवं श्री ब्रह्मा जी',
    godTitle: 'Supreme Guru of Divine Wisdom, Fortune & Grace',
    godTitleHi: 'परम गुरु, ज्ञान, भाग्य एवं दिव्यता के दाता',
    godSignificance: 'Bestows higher spiritual evolution, divine grace (Guru Kripa), righteous progeny, ethical wealth, expansive fortune (Bhagya), and shields against malice.',
    godSignificanceHi: 'दिव्य ज्ञान, आध्यात्मिक उन्नति, संतान सुख, भाग्य वृद्धि, उच्च शिक्षा एवं सभी संकटों से दैवीय सुरक्षा प्रदान करते हैं।',
    mantra: 'ॐ बृं बृहस्पतये नमः / ॐ दक्षिणामूर्तये नमः',
    avatarOrForm: 'Lord Vamana & Lord Brihaspati',
    avatarOrFormHi: 'भगवान वामन एवं देवगुरु बृहस्पति'
  },
  Venus: {
    planet: 'Venus (Shukra)',
    planetHi: 'शुक्र (Venus)',
    supremeGod: 'Goddess Maha Lakshmi & Goddess Durga',
    supremeGodHi: 'माँ महालक्ष्मी एवं माँ जगदम्बा दुर्गा',
    godTitle: 'Goddess of Abundance, Luxury, Aesthetics & Love',
    godTitleHi: 'ऐश्वर्य, सौंदर्य, माधुर्य एवं प्रेम की अधिष्ठात्री',
    godSignificance: 'Attracts financial prosperity (Aishwarya), marital harmony, creative genius, aesthetic refinement, vehicle comforts, and magnetic charisma.',
    godSignificanceHi: 'धन-धान्य, भौतिक सुख-सुविधाएं, दांपत्य मधुरता, कलात्मक प्रतिभा, आकर्षण एवं सौभाग्य की वर्षा करती हैं।',
    mantra: 'ॐ शुं शुक्राय नमः / ॐ श्रीं महालक्ष्म्यै नमः',
    avatarOrForm: 'Lord Parashurama & Goddess Annapurna',
    avatarOrFormHi: 'भगवान परशुराम एवं माँ अन्नपूर्णा'
  },
  Shukra: {
    planet: 'Venus (Shukra)',
    planetHi: 'शुक्र (Venus)',
    supremeGod: 'Goddess Maha Lakshmi & Goddess Durga',
    supremeGodHi: 'माँ महालक्ष्मी एवं माँ जगदम्बा दुर्गा',
    godTitle: 'Goddess of Abundance, Luxury, Aesthetics & Love',
    godTitleHi: 'ऐश्वर्य, सौंदर्य, माधुर्य एवं प्रेम की अधिष्ठात्री',
    godSignificance: 'Attracts financial prosperity (Aishwarya), marital harmony, creative genius, aesthetic refinement, vehicle comforts, and magnetic charisma.',
    godSignificanceHi: 'धन-धान्य, भौतिक सुख-सुविधाएं, दांपत्य मधुरता, कलात्मक प्रतिभा, आकर्षण एवं सौभाग्य की वर्षा करती हैं।',
    mantra: 'ॐ शुं शुक्राय नमः / ॐ श्रीं महालक्ष्म्यै नमः',
    avatarOrForm: 'Lord Parashurama & Goddess Annapurna',
    avatarOrFormHi: 'भगवान परशुराम एवं माँ अन्नपूर्णा'
  },
  Saturn: {
    planet: 'Saturn (Shani)',
    planetHi: 'शनि (Saturn)',
    supremeGod: 'Lord Shiva (Kala Bhairava) & Lord Hanuman',
    supremeGodHi: 'भगवान काल भैरव (शिव) एवं श्री हनुमान जी',
    godTitle: 'Dispenser of Karmic Justice, Discipline & Endurance',
    godTitleHi: 'न्यायाधीश, कर्मफल दाता, तपस्या व धैर्य के अधिपति',
    godSignificance: 'Bestows unshakeable endurance, long life, deep humility, karmic alignment, and transforms worldly hardships into lasting mastery and wisdom.',
    godSignificanceHi: 'धैर्य, दीर्घायु, अनुशासित कर्म, न्याय, एकाग्रता एवं संकटों को पार कर स्थायी सफलता का वरदान देते हैं।',
    mantra: 'ॐ शं शनैश्चराय नमः / ॐ कालभैरवाय नमः',
    avatarOrForm: 'Lord Kurma (Turtle Avatar) & Prajapati Yama',
    avatarOrFormHi: 'कूर्म अवतार एवं यमराज'
  },
  Shani: {
    planet: 'Saturn (Shani)',
    planetHi: 'शनि (Saturn)',
    supremeGod: 'Lord Shiva (Kala Bhairava) & Lord Hanuman',
    supremeGodHi: 'भगवान काल भैरव (शिव) एवं श्री हनुमान जी',
    godTitle: 'Dispenser of Karmic Justice, Discipline & Endurance',
    godTitleHi: 'न्यायाधीश, कर्मफल दाता, तपस्या व धैर्य के अधिपति',
    godSignificance: 'Bestows unshakeable endurance, long life, deep humility, karmic alignment, and transforms worldly hardships into lasting mastery and wisdom.',
    godSignificanceHi: 'धैर्य, दीर्घायु, अनुशासित कर्म, न्याय, एकाग्रता एवं संकटों को पार कर स्थायी सफलता का वरदान देते हैं।',
    mantra: 'ॐ शं शनैश्चराय नमः / ॐ कालभैरवाय नमः',
    avatarOrForm: 'Lord Kurma (Turtle Avatar) & Prajapati Yama',
    avatarOrFormHi: 'कूर्म अवतार एवं यमराज'
  },
  Rahu: {
    planet: 'Rahu (North Node)',
    planetHi: 'राहु (Rahu)',
    supremeGod: 'Goddess Durga (Chamunda / Mahishasuramardini) & Lord Bhairava',
    supremeGodHi: 'माँ दुर्गा (चामुण्डा) एवं भगवान भैरव',
    godTitle: 'Conqueror of Illusions & Giver of Unconventional Breakthroughs',
    godTitleHi: 'माया नाशक, आकस्मिक उत्थान व तंत्र रक्षक',
    godSignificance: 'Dissolves illusions (Maya), grants sudden triumphs in technology/foreign spheres, removes psychic afflictions, and cures ancestral (Sarpa) doshas.',
    godSignificanceHi: 'आकस्मिक सफलता, विदेशी लाभ, तकनीकी दक्षता, भ्रम व भय का निवारण तथा सर्प/पितृ दोष से मुक्ति प्रदान करती हैं।',
    mantra: 'ॐ रां राहवे नमः / ॐ दुं दुर्गायै नमः',
    avatarOrForm: 'Lord Varaha & Sheshanaga (Sarpa Devata)',
    avatarOrFormHi: 'भगवान वराह एवं शेषनाग'
  },
  Ketu: {
    planet: 'Ketu (South Node)',
    planetHi: 'केतु (Ketu)',
    supremeGod: 'Lord Ganesha (Vighnaharta) & Lord Matsya Avatar',
    supremeGodHi: 'श्री गणेश जी (विघ्नहर्ता) एवं भगवान मत्स्य',
    godTitle: 'Lord of Liberation (Moksha), Intuition & Secret Wisdom',
    godTitleHi: 'मोक्ष कारक, विघ्नहर्ता, आत्म-ज्ञान व अंतर्ज्ञान के दाता',
    godSignificance: 'Removes all subtle obstacles, unlocks spiritual liberation (Moksha), sharp occult discernment, and severs karmic bondage to bestow peace.',
    godSignificanceHi: 'समस्त विघ्नों का नाश, आध्यात्मिक सिद्धि, गूढ़ ज्ञान, अंतर्दृष्टि, मोक्ष प्राप्ति एवं आत्म-साक्षात्कार का मार्ग प्रशस्त करते हैं।',
    mantra: 'ॐ कें केतवे नमः / ॐ गं गणपतये नमः',
    avatarOrForm: 'Lord Matsya Avatar & Chitragupta',
    avatarOrFormHi: 'भगवान मत्स्य अवतार एवं चित्रगुप्त'
  }
};

// Sign ownership mapping
const SIGN_OWNERS: Record<number, string> = {
  0: 'Mars',    // Aries
  1: 'Venus',   // Taurus
  2: 'Mercury', // Gemini
  3: 'Moon',    // Cancer
  4: 'Sun',     // Leo
  5: 'Mercury', // Virgo
  6: 'Venus',   // Libra
  7: 'Mars',    // Scorpio
  8: 'Jupiter', // Sagittarius
  9: 'Saturn',  // Capricorn
  10: 'Saturn', // Aquarius
  11: 'Jupiter' // Pisces
};

const SIGN_NAMES_EN = [
  'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo',
  'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'
];

const SIGN_NAMES_HI = [
  'मेष (Aries)', 'वृषभ (Taurus)', 'मिथुन (Gemini)', 'कर्क (Cancer)', 'सिंह (Leo)', 'कन्या (Virgo)',
  'तुला (Libra)', 'वृश्चिक (Scorpio)', 'धनु (Sagittarius)', 'मकर (Capricorn)', 'कुम्भ (Aquarius)', 'मीन (Pisces)'
];

const BHAVA_THEMES_EN: Record<number, string> = {
  1: 'Self, Vitality, Persona & Longevity (Lagna)',
  2: 'Wealth, Family, Speech & Savings (Dhana)',
  3: 'Courage, Siblings, Initiative & Skills (Sahaja)',
  4: 'Home, Mother, Property & Peace (Sukha)',
  5: 'Intellect, Children, Creativity & Purva Punya (Suta)',
  6: 'Health, Victory over Debts & Competition (Ripu)',
  7: 'Marriage, Spouse, Business Partnerships (Jaya)',
  8: 'Longevity, Transformation & Occult Research (Mrityu/Randhra)',
  9: 'Fortune, Dharma, Higher Wisdom & Father (Bhagya)',
  10: 'Career, Karma, Fame & Social Leadership (Karma)',
  11: 'Gains, Expansion, Networks & Desires (Labha)',
  12: 'Spiritual Liberation, Foreign Travels & Expenses (Vyaya/Moksha)'
};

const BHAVA_THEMES_HI: Record<number, string> = {
  1: 'तनु भाव (शरीर, स्वास्थ्य, व्यक्तित्व व आत्मा)',
  2: 'धन भाव (कुटुंब, वाणी, संचित धन व पैतृक संपत्ति)',
  3: 'सहज भाव (पराक्रम, अनुज, साहस व संवाद)',
  4: 'सुख भाव (माता, गृह, भूमि, वाहन व मानसिक शांति)',
  5: 'सुत भाव (संतान, बुद्धि, पूर्व पुण्य व विवेक)',
  6: 'रिपु भाव (रोग, ऋण, शत्रु व प्रतिस्पर्धा पर विजय)',
  7: 'जाया भाव (दांपत्य, जीवनसाथी, व्यापारिक साझेदारी)',
  8: 'रंध्र भाव (आयु, गुप्त विद्या, परिवर्तन व शोध)',
  9: 'भाग्य भाव (धर्म, उच्च ज्ञान, पिता व तीर्थ यात्रा)',
  10: 'कर्म भाव (व्यवसाय, पद, प्रतिष्ठा व सामाजिक नेतृत्व)',
  11: 'लाभ भाव (आय, मित्र, अभिलाषा पूर्ति व नेटवर्क)',
  12: 'व्यय/मोक्ष भाव (विदेश, आध्यात्मिक मुक्ति व एकांत)'
};

export type ProfileLordNature = 'YOGAKARAKA' | 'LAGNA_LORD' | 'TRIKONA' | 'KENDRA' | 'MARAKA_DUSTHANA' | 'NEUTRAL';

export interface ProfileLordAnalysis {
  lordName: string;
  lordNameHi: string;
  lagnaSignName: string;
  lagnaSignNameHi: string;
  placedHouse: number | null;
  placedSignName: string;
  placedSignNameHi: string;
  ownedHouses: number[];
  ownedHousesTextEn: string;
  ownedHousesTextHi: string;
  functionalRoleEn: string;
  functionalRoleHi: string;
  roleNature: ProfileLordNature;
  profileSignificanceEn: string;
  profileSignificanceHi: string;
  deityInfo: PlanetLordDeityInfo;
}

/**
 * Calculates profile-specific Lordship, House placement, and functional impact for the native
 */
export function getProfileLordSignificance(
  kundali: CompleteKundali,
  nakIndex: number,
  isHi = false
): ProfileLordAnalysis {
  const nak = NAKSHATRAS[nakIndex % 27];
  const lordName = nak.lord;
  
  // Standardize lord key
  let standardLord = 'Jupiter';
  if (lordName.toLowerCase().includes('sun') || lordName.toLowerCase().includes('surya')) standardLord = 'Sun';
  else if (lordName.toLowerCase().includes('moon') || lordName.toLowerCase().includes('chandra')) standardLord = 'Moon';
  else if (lordName.toLowerCase().includes('mars') || lordName.toLowerCase().includes('mangal')) standardLord = 'Mars';
  else if (lordName.toLowerCase().includes('merc') || lordName.toLowerCase().includes('budh')) standardLord = 'Mercury';
  else if (lordName.toLowerCase().includes('jup') || lordName.toLowerCase().includes('guru')) standardLord = 'Jupiter';
  else if (lordName.toLowerCase().includes('ven') || lordName.toLowerCase().includes('shuk')) standardLord = 'Venus';
  else if (lordName.toLowerCase().includes('sat') || lordName.toLowerCase().includes('shan')) standardLord = 'Saturn';
  else if (lordName.toLowerCase().includes('rah')) standardLord = 'Rahu';
  else if (lordName.toLowerCase().includes('ket')) standardLord = 'Ketu';

  const deityInfo = PLANET_SUPREME_DEITIES[standardLord] || PLANET_SUPREME_DEITIES['Jupiter'];

  // Lagna Rashi Index
  const ascPlanet = kundali?.planets?.find(p => p.name.toLowerCase().includes('ascendant'));
  const ascSign = ascPlanet?.sign || kundali?.houses?.[0]?.sign || (kundali?.charts?.D1?.ascendantIndex !== undefined ? SIGN_NAMES_EN[kundali.charts.D1.ascendantIndex] : 'Aries');
  const lagnaIdx = SIGN_NAMES_EN.findIndex(s => s.toLowerCase() === (ascSign || '').toLowerCase());
  const effectiveLagnaIdx = lagnaIdx >= 0 ? lagnaIdx : 0;
  const lagnaSignName = SIGN_NAMES_EN[effectiveLagnaIdx];
  const lagnaSignNameHi = SIGN_NAMES_HI[effectiveLagnaIdx];

  // Find owned houses for this Lord based on Lagna
  const ownedHouses: number[] = [];
  if (standardLord !== 'Rahu' && standardLord !== 'Ketu') {
    for (let h = 1; h <= 12; h++) {
      const signOfHouse = (effectiveLagnaIdx + (h - 1)) % 12;
      if (SIGN_OWNERS[signOfHouse] === standardLord) {
        ownedHouses.push(h);
      }
    }
  }

  // Find native's planet position from kundali
  const planetData = kundali?.planets?.find(p => {
    const pName = p.name.toLowerCase();
    return (
      (standardLord === 'Sun' && (pName.includes('sun') || pName.includes('surya'))) ||
      (standardLord === 'Moon' && (pName.includes('moon') || pName.includes('chandra'))) ||
      (standardLord === 'Mars' && (pName.includes('mars') || pName.includes('mangal'))) ||
      (standardLord === 'Mercury' && (pName.includes('mercury') || pName.includes('budh'))) ||
      (standardLord === 'Jupiter' && (pName.includes('jupiter') || pName.includes('guru'))) ||
      (standardLord === 'Venus' && (pName.includes('venus') || pName.includes('shukra'))) ||
      (standardLord === 'Saturn' && (pName.includes('saturn') || pName.includes('shani'))) ||
      (standardLord === 'Rahu' && pName.includes('rahu')) ||
      (standardLord === 'Ketu' && pName.includes('ketu'))
    );
  });

  const placedHouse = planetData?.house || (planetData?.sign ? ((SIGN_NAMES_EN.findIndex(s => s.toLowerCase() === planetData.sign.toLowerCase()) - effectiveLagnaIdx + 12) % 12) + 1 : null);
  const placedSign = planetData?.sign || 'Aries';
  const placedSignIdx = SIGN_NAMES_EN.findIndex(s => s.toLowerCase() === placedSign.toLowerCase());
  const effectivePlacedSignIdx = placedSignIdx >= 0 ? placedSignIdx : 0;
  const placedSignName = SIGN_NAMES_EN[effectivePlacedSignIdx];
  const placedSignNameHi = SIGN_NAMES_HI[effectivePlacedSignIdx];

  // Build Owned Houses Text
  let ownedHousesTextEn = '';
  let ownedHousesTextHi = '';
  if (ownedHouses.length > 0) {
    const housesFormattedEn = ownedHouses.map(h => `${h}${h === 1 ? 'st' : h === 2 ? 'nd' : h === 3 ? 'rd' : 'th'} House`).join(' & ');
    const housesFormattedHi = ownedHouses.map(h => `${h}वां भाव`).join(' एवं ');
    const themesEn = ownedHouses.map(h => BHAVA_THEMES_EN[h]?.split('(')[0]?.trim()).join(' & ');
    const themesHi = ownedHouses.map(h => BHAVA_THEMES_HI[h]?.split('(')[0]?.trim()).join(' एवं ');
    ownedHousesTextEn = `Rules ${housesFormattedEn} (${themesEn})`;
    ownedHousesTextHi = `${housesFormattedHi} के स्वामी (${themesHi})`;
  } else {
    ownedHousesTextEn = standardLord === 'Rahu' ? 'Co-rules Aquarius & Shadow Node (Moksha/Desire axis)' : 'Co-rules Scorpio & Moksha Karaka';
    ownedHousesTextHi = standardLord === 'Rahu' ? 'कुम्भ राशि के सह-स्वामी व छाया ग्रह' : 'वृश्चिक राशि के सह-स्वामी व मोक्ष कारक ग्रह';
  }

  // Determine functional role (Lagna Lord, Yogakaraka, Trikona Lord, Kendra Lord, Dusthana Lord, Maraka)
  let functionalRoleEn = 'Active Graha Lord';
  let functionalRoleHi = 'सक्रिय ग्रह स्वामी';
  let roleNature: ProfileLordNature = 'NEUTRAL';

  const isLagnaLord = ownedHouses.includes(1);
  const isYogakaraka = (ownedHouses.includes(4) && ownedHouses.includes(9)) ||
                       (ownedHouses.includes(5) && ownedHouses.includes(10)) ||
                       (effectiveLagnaIdx === 1 && standardLord === 'Saturn') || // Taurus: Saturn (9 & 10)
                       (effectiveLagnaIdx === 6 && standardLord === 'Saturn') || // Libra: Saturn (4 & 5)
                       (effectiveLagnaIdx === 3 && standardLord === 'Mars') ||   // Cancer: Mars (5 & 10)
                       (effectiveLagnaIdx === 4 && standardLord === 'Mars');     // Leo: Mars (4 & 9)

  if (isLagnaLord) {
    functionalRoleEn = 'Primary Lagna Lord (Self, Vitality & Core Destiny Guardian)';
    functionalRoleHi = 'लग्नेश (जातक के मुख्य जीवन, स्वास्थ्य व आत्मबल के स्वामी)';
    roleNature = 'LAGNA_LORD';
  } else if (isYogakaraka) {
    functionalRoleEn = 'Prime Yogakaraka Lord (Supreme Auspiciousness & Raja Yoga Giver)';
    functionalRoleHi = 'परम राजयोगकारक ग्रह (सर्वोच्च सफलता व भाग्य प्रदाता)';
    roleNature = 'YOGAKARAKA';
  } else if (effectiveLagnaIdx === 3 && standardLord === 'Saturn') {
    // Cancer Ascendant: Saturn rules 7 (Maraka) & 8 (Randhra / Dusthana)
    functionalRoleEn = 'Maraka & 8th (Randhra) Lord (Karmic Discipline, Health & Longevity Guard)';
    functionalRoleHi = 'मारकेश एवं अष्टमेश (धैर्य, स्वास्थ्य रक्षा व कर्म शोधक)';
    roleNature = 'MARAKA_DUSTHANA';
  } else if (effectiveLagnaIdx === 4 && standardLord === 'Saturn') {
    // Leo Ascendant: Saturn rules 6 (Dusthana/Ripu) & 7 (Maraka)
    functionalRoleEn = '6th (Ripu) & 7th (Maraka) Lord (Discipline & Obstacle Resolution)';
    functionalRoleHi = 'षष्ठेश व मारकेश (अनुशासन, रोग निवारण व कर्म शुद्धि)';
    roleNature = 'MARAKA_DUSTHANA';
  } else if (ownedHouses.some(h => h === 5 || h === 9)) {
    functionalRoleEn = 'Trikona (Dharma/Bhagya) Lord (Bestower of Fortune & Punya)';
    functionalRoleHi = 'त्रिकोण / भाग्येश (पुण्य, विद्या एवं ईश्वरीय कृपा प्रदाता)';
    roleNature = 'TRIKONA';
  } else if (ownedHouses.some(h => h === 6 || h === 8 || h === 12)) {
    functionalRoleEn = 'Dusthana Lord (Transformation, Healing & Karmic Resolution)';
    functionalRoleHi = 'त्रिक भाव स्वामी (आंतरिक शोधन, साधना व संकट निवारक)';
    roleNature = 'MARAKA_DUSTHANA';
  } else if (ownedHouses.some(h => h === 4 || h === 7 || h === 10)) {
    functionalRoleEn = 'Kendra (Pillar) Lord (Career, Relationships & Material Foundation)';
    functionalRoleHi = 'केन्द्रेश (कार्यक्षेत्र, सुख व सामाजिक प्रतिष्ठा के आधार)';
    roleNature = 'KENDRA';
  }

  // Profile-specific interpretation
  let profileSignificanceEn = '';
  let profileSignificanceHi = '';

  const houseStrEn = placedHouse ? `${placedHouse}${placedHouse === 1 ? 'st' : placedHouse === 2 ? 'nd' : placedHouse === 3 ? 'rd' : 'th'} House` : 'Auspicious House';
  const houseStrHi = placedHouse ? `${placedHouse}वें भाव` : 'शुभ भाव';

  if (isLagnaLord) {
    profileSignificanceEn = `For your ${lagnaSignName} Ascendant, ${standardLord} is your Lagnesha (1st Lord) placed in the ${houseStrEn} (${placedSignName}). Whenever Moon transits this Nakshatra, your vital energy, decision-making clarity, and personal charisma are intensely heightened!`;
    profileSignificanceHi = `आपके ${lagnaSignNameHi} लग्न हेतु ${deityInfo.planetHi} आपके लग्नेश हैं तथा आपकी कुंडली के ${houseStrHi} (${placedSignNameHi}) में स्थित हैं। इस नक्षत्र में चंद्रमा के गोचर से आपका आत्मबल, मानसिक स्पष्टता एवं स्वास्थ्य विशेष रूप से पुष्ट होते हैं।`;
  } else if (isYogakaraka) {
    profileSignificanceEn = `For your ${lagnaSignName} Ascendant, ${standardLord} functions as your paramount Yogakaraka (ruling both Kendra and Trikona) situated in the ${houseStrEn}. Actions initiated in this Nakshatra receive unmatched structural momentum, prestige, and financial blessing!`;
    profileSignificanceHi = `आपके ${lagnaSignNameHi} लग्न हेतु ${deityInfo.planetHi} आपके सर्वोच्च योगकारक ग्रह हैं जो कुंडली के ${houseStrHi} में विराजमान हैं। इस नक्षत्र में आरंभ किए गए कार्यों को अप्रत्याशित सफलता, सम्मान एवं दैवीय सहायता प्राप्त होती है।`;
  } else if (effectiveLagnaIdx === 3 && standardLord === 'Saturn') {
    profileSignificanceEn = `For your Cancer Ascendant, Saturn rules your 7th (Maraka) & 8th (Randhra) houses, placed in the ${houseStrEn} (${placedSignName}). It requires strict discipline, cautious negotiations, and sadhana rather than reckless worldly ventures during active transits.`;
    profileSignificanceHi = `कर्क लग्न हेतु शनि आपके सप्तम (मारक) व अष्टम (रंध्र/आयु) भाव के स्वामी होकर ${houseStrHi} में स्थित हैं। यह गोचर नए अनुबंधों के स्थान पर सावधानी, धैर्य एवं साधना की प्रेरणा देता है।`;
  } else if (ownedHouses.includes(9) || ownedHouses.includes(5)) {
    const bhagyaHouse = ownedHouses.includes(9) ? '9th (Fortune/Bhagya)' : '5th (Wisdom/Purva Punya)';
    profileSignificanceEn = `For your ${lagnaSignName} Ascendant, ${standardLord} rules your ${bhagyaHouse} House and resides in the ${houseStrEn}. This Star directly activates your karmic merit, divine blessings, intuitive intellect, and smooth resolution of long-standing endeavors.`;
    profileSignificanceHi = `आपके ${lagnaSignNameHi} लग्न हेतु ${deityInfo.planetHi} आपके त्रिकोण/भाग्य भाव के स्वामी होकर ${houseStrHi} में स्थित हैं। यह नक्षत्र आपके पूर्व पुण्य, ईश्वरीय कृपा व भाग्य को जागृत करता है।`;
  } else if (ownedHouses.includes(10) || ownedHouses.includes(2) || ownedHouses.includes(11)) {
    profileSignificanceEn = `For your ${lagnaSignName} Ascendant, ${standardLord} commands your wealth & career bhavas (${ownedHouses.join(', ')}), placed in the ${houseStrEn}. Transiting this Nakshatra triggers professional expansion, commercial negotiations, and fruitful financial milestones.`;
    profileSignificanceHi = `आपके ${lagnaSignNameHi} लग्न हेतु ${deityInfo.planetHi} आपके अर्थ व कर्म भावों के स्वामी हैं तथा ${houseStrHi} में स्थित हैं। यह नक्षत्र व्यापारिक समझौतों, आर्थिक लाभ एवं पदोन्नति हेतु विशेष फलदायी है।`;
  } else {
    profileSignificanceEn = `For your ${lagnaSignName} Ascendant, ${standardLord} (${ownedHousesTextEn}) resides in your ${houseStrEn} (${placedSignName}). It channels specialized focus, discipline, and karmic refinement for your personal chart.`;
    profileSignificanceHi = `आपके ${lagnaSignNameHi} लग्न हेतु ${deityInfo.planetHi} (${ownedHousesTextHi}) आपकी कुंडली के ${houseStrHi} में स्थित हैं। यह नक्षत्र आपकी कुंडली में विशिष्ट एकाग्रता व कर्म सुधार का संचार करता है।`;
  }

  return {
    lordName: standardLord,
    lordNameHi: deityInfo.planetHi,
    lagnaSignName,
    lagnaSignNameHi,
    placedHouse,
    placedSignName,
    placedSignNameHi,
    ownedHouses,
    ownedHousesTextEn,
    ownedHousesTextHi,
    functionalRoleEn,
    functionalRoleHi,
    roleNature,
    profileSignificanceEn,
    profileSignificanceHi,
    deityInfo
  };
}
